import React, { useState } from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { SelectMultipleHierarchy } from 'app/area/shared/translated-components';

export interface PopupAddNewSelectProps {
  valueItems: ComplexValue<number>[];
  onChange: (values: ComplexValue<number>[]) => void;

  options: ComplexValue<number>[];
  fetchingOptions: boolean;
  shouldSortSelectedItems?: boolean;
  loadOptions: (loadOptionsParams: LoadOptions) => void;

  descriptionAllLevels: boolean;
  searchPlaceholder: string;
  readOnlyItemIds?: number[];
  locale: string;
}

export const PopupAddNewSelect: React.FC<PopupAddNewSelectProps> = ({
  valueItems, onChange, readOnlyItemIds, locale,
  options, fetchingOptions, shouldSortSelectedItems, loadOptions,
  descriptionAllLevels, searchPlaceholder
}) => {

  const [domainLoadOptions, setDomainLoadOptions] = useState<LoadOptions>();

  const onDomainLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(loadOptionsParams);
    setDomainLoadOptions(loadOptionsParams);
  };

  return <SelectMultipleHierarchy
    componentId="dashboard-popup-picker"
    className={undefined}
    placeholder={searchPlaceholder}
    valueItems={valueItems}
    shouldSortSelectedItems={shouldSortSelectedItems}
    onChange={onChange}
    options={options}
    loadOptions={domainLoadOptions}
    onLoadOptions={onDomainLoadOptions}
    fetching={fetchingOptions}
    alwaysOpen={true}
    leafNodeOnly={true}
    descriptionAllLevels={descriptionAllLevels}
    displaySelectAll={true}
    readOnlyItemIds={readOnlyItemIds}
    locale={locale}
  />;
};
